
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSleetShowersDay as ObiLightSleetShowersDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-sleet-showers-day.js';
 
 
 

 
 export const ObiLightSleetShowersDay = createComponent({
   react: React,
   tagName: 'obi-light-sleet-showers-day',
   elementClass: ObiLightSleetShowersDayElement,
   events: {
     
   }
  });
 
 